import React, { useState } from 'react'

import DeleteIcon from '@mui/icons-material/Delete'
import { Button, CardHeader } from '@mui/material'
import AddCustomerDomain from 'features/customers/components/domains/AddCustomerDomain'
import { useCustomerDomainCreate } from 'features/customers/hooks/useCustomerDomainCreate'
import { useCustomerDomainRemove } from 'features/customers/hooks/useCustomerDomainRemove'
import { useCustomerDomains } from 'features/customers/hooks/useCustomerDomains'
import { useCustomerFeatures } from 'features/customers/hooks/useCustomerFeatures'

import { EFeatureNames } from '@albacross/types'

import LoadingView from 'components/LoadingView'
import { SimpleTable } from 'components/table'

const CustomerDomains = () => {
  const { data: domains, isLoading } = useCustomerDomains()
  const { data: features } = useCustomerFeatures()

  const { mutateAsync: createDomain } = useCustomerDomainCreate()
  const { mutateAsync: removeDomain } = useCustomerDomainRemove()

  const [addingNew, setAddingNew] = useState(false)

  const handleAddDomain = async domain => createDomain(domain)
  const handleRemoveDomain = id => async () => removeDomain(id)

  const config = [
    {
      title: 'Name',
      field: 'domain',
    },
    {
      // eslint-disable-next-line react/prop-types
      render: ({ id }) => (
        <Button onClick={handleRemoveDomain(id)}>
          <DeleteIcon />
        </Button>
      ),
    },
  ]

  const canAddDomains = domains?.length >= features[EFeatureNames.DomainsLimit]

  return (
    <>
      <CardHeader
        action={
          <Button disabled={canAddDomains} onClick={() => setAddingNew(true)}>
            Add domain
          </Button>
        }
      />
      <LoadingView loading={isLoading}>
        <SimpleTable config={config} data={domains || []} striped />
      </LoadingView>
      <AddCustomerDomain onAdd={handleAddDomain} onClose={() => setAddingNew(false)} open={addingNew} />
    </>
  )
}

export default CustomerDomains
